export const insightImpactLevels = {
  low: {
    label: "Low Impact",
    value: "low",
    color: "violet"
  },
  medium: {
    label: "Medium Impact",
    value: "medium",
    color: "yellow"
  },
  high: {
    label: "High Impact",
    value: "high",
    color: "green"
  }
} as const;

export const insightConfidenceLevels = {
  low: {
    label: "Low Confidence",
    value: "low",
    color: "violet"
  },
  medium: {
    label: "Medium Confidence",
    value: "medium",
    color: "yellow"
  },
  high: {
    label: "High Confidence",
    value: "high",
    color: "green"
  }
} as const;

export const insightTypes = {
  revenue: {
    label: "Revenue",
    value: "revenue"
  },
  retention: {
    label: "Retention",
    value: "retention"
  },
  acquisition: {
    label: "Acquisition",
    value: "acquisition"
  },
  efficiency: {
    label: "Efficiency",
    value: "efficiency"
  },
  experience: {
    label: "Experience",
    value: "experience"
  }
} as const;
